import { Controller } from '@hotwired/stimulus'
import { trackSegment } from '../utils/track'

export default class extends Controller {
  static targets = ['button']

  click() {
    const title = this.buttonTarget.dataset.dealTabsTitle
    const text = this.buttonTarget.dataset.dealTabsButtonText
    trackSegment('Element Clicked', {
      element_name: title,
      element_text: text,
      element_type: 'button'
    })
  }
}
